import { tryOnScopeDispose } from '@vueuse/core'
export const useWishlist = async () => {
  if (import.meta.server) { return }
  const authStore = useAuthStore()
  const wishlistStore = useWishlistStore()

  const initWishlist = async () => {
    await nextTick()
    if (authStore.loggedIn) {
      if (!wishlistStore.wishlistId) {
        await wishlistStore.retrieveAccountListId()
      }
      await wishlistStore.sync()
    }
  }

  await initWishlist()

  const stopWatcher = watch(() => authStore.loggedIn, async loggedIn => {
    if (loggedIn) {
      await initWishlist()
    }
  })

  tryOnScopeDispose(stopWatcher)
}
